import { render, staticRenderFns } from "./call_activity_report_page.vue?vue&type=template&id=28dc3efe&scoped=true"
import script from "./call_activity_report_page.vue?vue&type=script&lang=js"
export * from "./call_activity_report_page.vue?vue&type=script&lang=js"
import style0 from "./call_activity_report_page.vue?vue&type=style&index=0&id=28dc3efe&prod&scoped=true&lang=css"
import style1 from "./call_activity_report_page.vue?vue&type=style&index=1&id=28dc3efe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dc3efe",
  null
  
)

export default component.exports